/** University Manager demo uses mock data and is reachable without login. */
export const UNIVERSITY_MANAGER_BASE_PATH = "/university-manager";

export const isUniversityManagerDemoPath = (pathname = "") =>
  pathname.startsWith(UNIVERSITY_MANAGER_BASE_PATH);
